module.exports = "<div *ngIf=\"isInvalidInput()\" class=\"ui basic red pointing prompt label transition\">\n  {{ errorMessage }}\n</div>\n"